import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    // Cargar tema desde localStorage
    const saved = localStorage.getItem('theme');
    // Si no hay tema guardado, usar dark por defecto
    if (saved === null) {
      return true; // Dark mode por defecto
    }
    return saved === 'dark';
  });

  useEffect(() => {
    // Guardar tema en localStorage
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    
    // Aplicar/remover clase dark al body
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
